import { faArrowCircleUp } from '@fortawesome/free-solid-svg-icons';
import * as S from './styles'
import { useState, useEffect } from 'react'

const CatalogBackToTop = () => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsVisible(true)
      } else {
        setIsVisible(false)
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }
  
  return (
    <S.CatalogBackToTop 
      onClick={scrollToTop}
      className={isVisible ? 'visible' : 'hidden'}
    >
      <S.CatalogBackToTopWrapper>
        <S.CatalogBackToTopIcon icon={faArrowCircleUp} />
      </S.CatalogBackToTopWrapper>
    </S.CatalogBackToTop>
  )
}

export default CatalogBackToTop